
<template>
    <div class="popupComponent commonComponent">
        <div class="shadow" @click="handlClose()"></div>
        <div class="popupContainer">
            <div class="popupBody">
                <header v-if="alertdata.title">
                    <div class="list">
                        <div class="item title_item">
                            <div class="title">{{ alertdata.title }}</div>
                        </div>
                        <div class="item subTitle_item" v-if="alertdata.subTitle">
                            <div class="title">{{ alertdata.subTitle }}</div>
                        </div>
                    </div>
                </header>
                <section>
                    <aside class="text_aside" v-if="alertdata.type == 'text'">
                        <div class="list">
                            <div class="item">
                                <div class="title">{{ alertdata.content }}</div>
                            </div>
                        </div>
                    </aside>
                    <aside class="form_aside" v-if="alertdata.type == 'form'">
                        <div class="list">
                            <div :class="telWrongFlag ? 'actived item tel_item' : 'item tel_item'">
                                <div class="iptBox">
                                    <input v-model="tel" maxlength="11" :placeholder="tel_placeholder" type="tel" @blur.prevent="inputLoseFocus" />
                                </div>
                            </div>
                            <div :class="msgCodeWrongFlag ? 'actived item code_item' : 'item code_item'">
                                <!-- 短信验证码 -->
                                <div class="iptBox" v-if="isMsgCodeFlag">
                                    <input v-model="msgCode" maxlength="6" :placeholder="code_placeholder" type="text" @blur.prevent="inputLoseFocus" />
                                </div>
                                <div class="btnBox" v-if="isMsgCodeFlag" @click="sendMsgCode()">
                                    <div class="title">{{ sendCodeText }}</div>
                                </div>
                                <!-- 图片验证码 -->
                                <div class="iptBox" v-if="!isMsgCodeFlag">
                                    <input v-model="msgCode" maxlength="4" :placeholder="code_placeholder" type="text" @blur.prevent="inputLoseFocus" />
                                </div>
                                <div class="codeBox" v-if="!isMsgCodeFlag" @click="changeCode()">
                                    <img :src="codeURL" alt="" />
                                </div>
                            </div>
                        </div>
                    </aside>
                </section>
                <footer>
                    <div class="list">
                        <div class="item cancel_item" v-if="alertdata.cancelText" @click="handleCancel()">
                            <div class="title">{{ alertdata.cancelText }}</div>
                        </div>
                        <div :class="isAvailableFlag ? 'actived center_bg' : 'center_bg'" v-if="alertdata.cancelText && alertdata.confirmText"></div>
                        <div :class="isAvailableFlag ? 'item actived_item confirm_item' : 'item confirm_item'" v-if="alertdata.confirmText" @click="handleConfirm()">
                            <div class="title">{{ alertdata.confirmText }}</div>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from '../libs/http/axios-others';
    import QS from 'qs';
    import { Toast } from 'mint-ui';

    export default {
        data () {
            return {
                tel: "",
                msgCode: "",
                sendCodeText: "发送验证码",
                tel_placeholder: "请输入手机号",
                telWrongFlag: false,
                code_placeholder: "请输入验证码",
                msgCodeWrongFlag: false,
                isAvailableFlag: false,
                codeURL: "",
                sendedTime: 60,
                timer: null,
                isMsgCodeFlag: true,
                isCanSendFlag: true,

                testNum: 1,
            }
        },
        props: {
            alertdata: {
                type: Object,
                default: {},
            }
        },
        created () {
            if(this.alertdata.type == "text"){
                this.isAvailableFlag = true;
            }
        },
        watch: {
            tel: function (newVal, oldVal) {
                if(newVal){
                    this.telWrongFlag = false;
                    this.tel_placeholder = "请输入手机号";
                }
                if(this.alertdata.type == "form"){
                    if (newVal.length == 11 && this.msgCode != "") {
                        this.isAvailableFlag = true;
                    } else {
                        this.isAvailableFlag = false;
                    }
                }else{
                    this.isAvailableFlag = true;
                }
            },
            msgCode: function (newVal, oldVal) {
                if(newVal){
                    this.msgCodeWrongFlag = false;
                    this.code_placeholder = "请输入验证码";
                }
                if(this.alertdata.type == 'form'){
                    if(this.isMsgCodeFlag == true || this.isMsgCodeFlag == "true"){
                        if (newVal.length == 6 && this.tel != "") {
                            this.isAvailableFlag = true;
                        } else {
                            this.isAvailableFlag = false;
                        }
                    }else{
                        if (newVal.length == 4 && this.tel != "") {
                            this.isAvailableFlag = true;
                        } else {
                            this.isAvailableFlag = false;
                        }
                    }
                }else{
                    this.isAvailableFlag = true;
                }
            },
            telWrongFlag: function (newVal, oldVal) {
                if(newVal == true || newVal == "true"){
                    this.tel = "";
                    this.tel_placeholder = "手机号格式不正确";
                }
            },
            msgCodeWrongFlag: function (newVal, oldVal) {
                if(newVal == true || newVal == "true"){
                    this.msgCode = "";
                    this.code_placeholder = "验证码错误";
                }
            },
        },
        mounted () {

        },
        methods: {
            inputLoseFocus(){
                setTimeout(() => {
                    const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
                    window.scrollTo({
                        top: scrollHeight,
                        behavior: "smooth",
                    });
                }, 100);
            },
            sendMsgCode(){
                if(this.isCanSendFlag && this.tel.length == 11){
                    let params = {
                        isPic: "n",
                        picCode: "",
                        sim: this.tel,
                    }
                    this.$http.request({
                        method: "post",
                        url: "/app/h5Regist/smsCodeV1.json",
                        params: params,
                        noToast: true,
                    }).then((res) => {
                        this.msgCodeWrongFlag = false;

                        // this.testNum = this.testNum + 1;
                        // if(this.testNum == 3){
                        //     res.data.modelData.pic = "true";
                        // }

                        this.msgCode = "";
                        if (res.data.code === 200) {
                            if(res.data.modelData.pic == "false" || res.data.modelData.pic == false){ // 短信验证码
                                this.isCanSendFlag = false;
                                // Toast({
                                //     message: "发送成功",
                                //     position: "top",
                                //     duration: 3000,
                                // });
                                Toast("发送成功");
                                clearInterval(this.timer);
                                this.timer = null;
                                if(res.data.modelData.second){
                                    this.sendedTime = res.data.modelData.second * 1;
                                }
                                this.timer = setInterval(() => {
                                    this.sendCodeText = `${ this.sendedTime }s`;
                                    this.sendedTime = this.sendedTime - 1;
                                    if(this.sendedTime == 0){
                                        clearInterval(this.timer);
                                        this.timer = null;
                                        this.sendCodeText = "再次发送";
                                        this.isCanSendFlag = true;
                                    }
                                }, 1000);
                            }else{ // 图片验证码
                                this.changeCode()
                                this.isMsgCodeFlag = false;
                            }

                        }else if(res.data.code == 1118){
                            this.telWrongFlag = true;
                        }else if(res.data.code == 3202){ // 操作过于频繁，请45秒后再试
                            Toast(res.data.desc);
                        }else if(res.data.code == 3204){ // 操作过于频繁，请42分钟后再试
                            Toast(res.data.desc);
                        }else{
                            if(res.data.modelData.pic == "true" || res.data.modelData.pic == true){
                                if(!this.codeURL){
                                    this.changeCode()
                                }
                                this.isMsgCodeFlag = false;
                            }else{
                                this.isMsgCodeFlag = true;
                            }
                            // Toast({
                            //     message: res.data.desc,
                            //     position: "top",
                            //     duration: 3000,
                            // });
                            // Toast(res.data.desc);
                        }
                    })
                }
            },
            changeCode(){
                if(this.tel.length == 11){
                    this.codeURL = `${ process.env.API_ROOT }/app/h5Regist/getPicCode.json?updateCode=0&num=${ new Date().getTime() }&sim=${ this.tel }`;
                }
            },
            handlClose(){

            },
            handleCancel(){
                // this.telWrongFlag = true;
                this.alertdata.cancelCallback();
            },
            handleConfirm(){
                if(this.alertdata.type == "form"){
                    if(this.tel && this.msgCode){

                        if(this.isMsgCodeFlag){
                            this.$http.request({
                                method: "post",
                                url: "/user/login.json",
                                params: {
                                    code: this.msgCode,
                                    sim: this.tel,
                                    notUpdateToken: "1",
                                    isPic: this.isMsgCodeFlag ? "n" : "y",
                                },
                                noToast: true,
                            }).then((res) => {
                                if (res.data.code === 200) {
                                    // Toast("登陆成功");
                                    // Toast({
                                    //     message: "成功",
                                    //     position: "top",
                                    //     duration: 3000,
                                    // });
                                    this.alertdata.confirmCallback(res.data);
                                }else if(res.data.code == 2100){
                                    this.msgCodeWrongFlag = true;
                                }else{
                                    // Toast({
                                    //     message: res.data.desc,
                                    //     position: "top",
                                    //     duration: 3000,
                                    // });
                                    // Toast(res.data.desc);
                                }
                            })
                        }else{
                            let params = {
                                isPic: "y",
                                picCode: this.msgCode,
                                sim: this.tel,
                            }
                            this.$http.request({
                                method: "post",
                                url: "/app/h5Regist/smsCodeV1.json",
                                params: params,
                                noToast: true,
                            }).then((res) => {
                                this.msgCodeWrongFlag = false;
                                this.msgCode = "";
                                if (res.data.code === 200) {
                                    // if(res.data.modelData.pic == "false" || res.data.modelData.pic == false){ // 短信验证码
                                        this.isMsgCodeFlag = true;
                                        this.isCanSendFlag = false;
                                        // Toast({
                                        //     message: "发送成功",
                                        //     position: "top",
                                        //     duration: 3000,
                                        // });
                                        Toast("发送成功");
                                        clearInterval(this.timer);
                                        this.timer = null;
                                        if(res.data.modelData.second){
                                            this.sendedTime = res.data.modelData.second * 1;
                                        }
                                        this.timer = setInterval(() => {
                                            this.sendCodeText = `${ this.sendedTime }s`;
                                            this.sendedTime = this.sendedTime - 1;
                                            if(this.sendedTime == 0){
                                                clearInterval(this.timer);
                                                this.timer = null;
                                                this.sendCodeText = "再次发送";
                                                this.isCanSendFlag = true;
                                            }
                                        }, 1000);
                                    // }else{ // 图片验证码
                                    //     this.changeCode()
                                    //     this.isMsgCodeFlag = false;
                                    // }

                                }else if(res.data.code == 1118){
                                    this.telWrongFlag = true;
                                }else if(res.data.code == 2100){
                                    this.msgCodeWrongFlag = true;
                                    Toast(res.data.desc);
                                }else if(res.data.code == 3202){ // 操作过于频繁，请45秒后再试
                                    this.msgCodeWrongFlag = true;
                                    Toast(res.data.desc);
                                }else if(res.data.code == 3204){ // 操作过于频繁，请45分钟后再试
                                    this.msgCodeWrongFlag = true;
                                    Toast(res.data.desc);
                                }else{
                                    // if(res.data.modelData.pic == "true" || res.data.modelData.pic == true){
                                    //     this.changeCode()
                                    //     this.isMsgCodeFlag = false;
                                    // }else{
                                    //     this.isMsgCodeFlag = true;
                                    // }
                                    // Toast({
                                    //     message: res.data.desc,
                                    //     position: "top",
                                    //     duration: 3000,
                                    // });
                                    // Toast(res.data.desc);
                                }
                            })
                        }

                    }
                }else{
                    this.alertdata.confirmCallback();
                }
            },
        },
    }
</script>

<style scoped lang="scss">
    @mixin vertical_horizontal_center($direction){
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        @if ($direction == y){
            -webkit-box-align: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            -webkit-align-items: center;
            align-items: center;
        }
        @else if($direction == x){
            -webkit-box-pack: center;
            -moz-box-pack: center;
            -ms-flex-pack: center;
            -webkit-justify-content: center;
            justify-content: center;
        }
        @else {
            -webkit-box-align: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            -webkit-align-items: center;
            align-items: center;

            -webkit-box-pack: center;
            -moz-box-pack: center;
            -ms-flex-pack: center;
            -webkit-justify-content: center;
            justify-content: center;
        }
    }
    @mixin flex_num($num:1){
        flex: $num;
        -webkit-flex: $num;
        -ms-flex: $num;
        -moz-box-flex: $num;
    }
    @mixin flex_common($direction){
        display: flex;
        display: -ms-flex;
        display: -webkit-flex;
        display: -moz-flex;
        @if($direction == x){
            flex-direction: row;
            -ms-flex-direction: row;
            -webkit-flex-direction: row;
        }
        @else if($direction == y){
            flex-direction: column;
            -ms-flex-direction: column;
            -webkit-flex-direction: column;
        }
    }
    @mixin flex_direction($direction){
        @if($direction == x){
            flex-direction: row;
            -ms-flex-direction: row;
            -webkit-flex-direction: row;
        }
        @else if($direction == y){
            flex-direction: column;
            -ms-flex-direction: column;
            -webkit-flex-direction: column;
        }
    }
    @mixin flex_wrap(){
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        -ms-flex-wrap: wrap;
        -moz-box-flex-wrap: wrap;
        -o-flex-wrap: wrap;
    }
    @mixin img_common(){
        display: block;
        border: 0;
        border: none;
        padding: 0;
        margin: 0;
    }
    @mixin ipt_common(){
        display: block;
        padding: 0;
        margin: 0;
    }

    .popupComponent {
        font-size: 30px;
        height: 100vh;
        width: 100%;
        z-index: 6;
        opacity: 1;
        background-color: rgba(0, 0, 0, .4);
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        @include flex_common(x);
        @include vertical_horizontal_center(both);
        .shadow{
            height: 100vh;
            width: 100%;
            z-index: 6;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
        }
        .popupContainer {
            width: 630px;
            min-height: 400px;
            max-height: 600px;
            position: absolute;
            z-index: 8;
            background: #141E25;
            box-shadow: 0 30px 50px 0 rgba(0,0,0,0.10);
            border-radius: 4px;
            overflow: hidden;
            color: #ffffff;
            @include flex_common(y);
            .popupBody{
                overflow: hidden;
                @include flex_num(1);
                @include flex_common(y);
                box-sizing: content-box;
                padding: 60px 0 0;
                header{
                    padding: 0 60px;
                    margin-bottom: 30px;
                    .list{
                        .item{
                            .title{
                                text-align: left;
                            }
                            &.title_item{
                                //font-family: FZLTTHJW--GB1-0;
                                height: 50px;
                                font-size: 40px;
                                line-height: 50px;
                                color: #FFFFFF;
                            }
                            &.subTitle_item{
                                //font-family: FZLTHJW--GB1-0;
                                margin-top: 6px;
                                font-size: 24px;
                                color: #FFFFFF;
                                line-height: 32px;
                            }
                        }
                    }
                }
                section{
                    overflow: auto;
                    padding: 0 60px;
                    @include flex_num(1);
                    height: 250px;
                    aside{
                        &.text_aside{
                            .list{
                                .item{
                                    .title{
                                        //font-family: FZLTHJW--GB1-0;
                                        font-size: 30px;
                                        color: rgba(255,255,255,0.60);
                                        line-height: 40px;
                                    }
                                }
                            }
                        }
                        &.form_aside{
                            margin-bottom: 60px;
                            height: 190px;
                            .list{
                                height: 190px;
                                .tel_item{
                                    height: 80px;
                                    margin-bottom: 30px;
                                    padding: 0 30px;
                                    background: rgba(255,255,255,0.15);
                                    &.actived{
                                        background: rgba(214,20,129,0.70);
                                        input::-webkit-input-placeholder {
                                            color: #ffffff;
                                        }
                                        input::-ms-input-placeholder {
                                            color: #ffffff;
                                        }
                                        input:-ms-input-placeholder {
                                            color: #ffffff;
                                        }
                                        input::-moz-placeholder {
                                            color: #ffffff;
                                        }
                                        input:-moz-placeholder {
                                            color: #ffffff;
                                        }
                                    }
                                    .iptBox{
                                        box-sizing: content-box;
                                        input{
                                            height: 80px;
                                            width: 100%;
                                            opacity: 0.7;
                                            border-radius: 4px;
                                            @include ipt_common();
                                            //font-family: FZLTHJW--GB1-0;
                                            font-size: 30px;
                                            color: #FFFFFF;
                                        }
                                    }
                                }
                                .code_item{
                                    @include flex_common(x);
                                    @include vertical_horizontal_center(y);
                                    background: rgba(255,255,255,0.15);
                                    padding: 0 0 0 30px;
                                    height: 80px;
                                    &.actived{
                                        background: rgba(214,20,129,0.70);
                                        input::-webkit-input-placeholder {
                                            color: #ffffff;
                                        }
                                        input::-ms-input-placeholder {
                                            color: #ffffff;
                                        }
                                        input:-ms-input-placeholder {
                                            color: #ffffff;
                                        }
                                        input::-moz-placeholder {
                                            color: #ffffff;
                                        }
                                        input:-moz-placeholder {
                                            color: #ffffff;
                                        }
                                    }
                                    .iptBox{
                                        box-sizing: content-box;
                                        @include flex_num(1);
                                        input{
                                            height: 80px;
                                            width: 100%;
                                            opacity: 0.7;
                                            border-radius: 4px;
                                            @include ipt_common();
                                            font-size: 30px;
                                            color: #FFFFFF;
                                        }
                                    }
                                    .btnBox{
                                        width: 160px;
                                        margin-right: 30px;
                                        .title{
                                            width: 100%;
                                            // font-family: FZLTHJW--GB1-0;
                                            font-size: 30px;
                                            color: #FFFFFF;
                                            text-align: right;
                                        }
                                    }
                                    .codeBox{
                                        height: 100%;
                                        width: 160px;
                                        overflow: hidden;
                                        img{
                                            @include img_common();
                                            width: 100%;
                                            height: 100%;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                footer{
                    height: 110px;
                    width: 100%;
                    .list{
                        width: 100%;
                        height: 100%;
                        @include flex_common(x);
                        .item{
                            @include flex_num(1);
                            line-height: 110px;
                            .title{

                            }
                            &.cancel_item{
                                background: #3C464C;
                                border-radius: 0 0 4px 0;
                                .title{
                                    //font-family: FZLTHJW--GB1-0;
                                    font-size: 40px;
                                    color: #FFFFFF;
                                    text-align: center;
                                }
                            }
                            &.confirm_item{
                                &.actived_item{
                                    background: #02D644;

                                }
                                background: #B0BCC6;
                                border-radius: 0 0 4px 0;
                                .title{
                                    //font-family: FZLTTHJW--GB1-0;
                                    font-size: 40px;
                                    color: #FFFFFF;
                                    text-align: center;
                                }
                            }
                        }
                        .center_bg{
                            transform: scaleX(1.1);
                            height: 100%;
                            width: 45px;
                            background: url("../assets/images/transfer/center_bg.png") no-repeat center center;
                            background-size: 100% 100%;
                            &.actived{
                                background: url("../assets/images/transfer/border_center.png") no-repeat center center;
                                background-size: 100% 100%;
                            }
                        }
                    }
                }
            }
        }
    }

    .mint-toast{
        z-index: 999999999999!important;
    }
</style>



// WEBPACK FOOTER //
// popup-component.vue?6e77daa9